// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import './style.css'

// import required modules
import { Pagination, Navigation } from 'swiper'

interface quotes {
  quoteContent: string | undefined
  withoutQuotes: string | undefined
  bold: string | undefined
  fontFamily: string | undefined
}

const QuoteSwiper = ({ quoteContent, withoutQuotes, bold, fontFamily }: quotes) => {
  // const leftB=useRef(null);
  // const rightB=useRef(null);

  // const LB= <LeftButton ref={leftB} className="swiper-button-prev" />
  // const RB= <RightButton ref={rightB} className="swiper-button-next" />

  var content =
    quoteContent === undefined
      ? [['Ich glaube hier fehlt was.', 'sicher 40']]
      : JSON.parse(quoteContent)

  return (
    <>
      <CarouselBox
        slidesPerView={1}
        navigation={true}
        centeredSlides={true}
        spaceBetween={20}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Navigation]}
      >
        {content.map((item: [string, string], idx: string) => {
          return (
            <SwipeElement key={idx}>
              <SwipeContent withoutQuotes={withoutQuotes} bold={bold} fontFamily={fontFamily}>
              {item[0]} {withoutQuotes !== 'true' ? "»" : ""}<span>{item[1]}</span>
              </SwipeContent>
            </SwipeElement>
          )
        })}
      </CarouselBox>
    </>
  )
}

export default QuoteSwiper

const CarouselBox = styled(Swiper)`
  width: 100%;
  max-width: 900px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  vertical-align: middle;
  height: auto;
  display: flex;
  margin-top: 0.5em;
  margin-bottom: 6rem;
  @media only screen and (max-width: 711px) {
    margin-bottom: 4rem;
  }
  .swiper-button-next {
    right: var(--swiper-navigation-sides-offset,5px);
  }
  .swiper-button-prev {
    left: var(--swiper-navigation-sides-offset,15px);
  }
`

const SwipeElement = styled(SwiperSlide)`
  text-align: left;
  font-size: 18px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 0;
  margin-right: 0;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  display: flex;
  justify-content: center;
`

const SwipeContent = styled.div<{ withoutQuotes?: string, bold?: string, fontFamily?: string }>`
  /* Center slide text vertically */
  font-size: 1em;
  padding: 1.35em 50px;
  padding-bottom: 2em;
  font-family: ${props => props.fontFamily === 'noto' ? "var(--font-serif)" : "var(--font-sans-serif)"};
  /* font-style: italic; */
  ${props => props.bold !== 'true' && "font-style: italic;"}
  font-weight: ${props => props.bold === 'true' ? "600" : "400"};

  line-height: 1.45;
  color: var(--quote-color);
  position: relative;
  quotes: '«' '»' '«' '»';
  @media only screen and (min-width: 712px) {
    font-size: 3rem;
    padding: 1.35em 70px;
  }

  &::before {
    ${props => props.withoutQuotes === 'true' && "display: none;"}
    padding-left: 10px;
    content: open-quote;
    position: absolute;
    font-size: 3em;
    font-weight: normal;
    left: 0px;
    top: -10px;
    color: #7a7a7a;
  }
  span {
    padding-top: 1.5rem;
    font-family: var(--font-sans-serif);
    display: block;
    font-size: 0.8em;
    font-style: normal;
    font-weight: normal;
    color: #7a7a7a;
    font-size: 1.5rem;
    @media only screen and (min-width: 712px) {

    padding-top: 1.5rem;
  }
  }
  /* display: flex; */
  justify-content: center;
  align-items: center;
  width: 60%;
  @media screen and (min-width: 1000px) {
    width: 50%;
  }
`
